import { render } from "./BseShow.vue?vue&type=template&id=16455f20"
import script from "./BseShow.vue?vue&type=script&lang=js"
export * from "./BseShow.vue?vue&type=script&lang=js"

import "./BseShow.vue?vue&type=style&index=0&id=16455f20&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__